export enum Region {
  NAM = 'Domestic (NAM)',
  EMEA = 'Europe, Middle East, and Africa (EMEA)',
  APAC = 'Asia Pacific (APAC)',
  LATAM = 'Latin America (LATAM)',
}
